import React, { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import HouseholdItemsForm from './HouseholdItemsForm';
import HouseholdItemsAdmin from './HouseholdItemsAdmin';
import { Tab, Tabs } from 'react-bootstrap';
import PageAccessManager from '../components/PageAccessManager';

// Mirrors StayBenefitHome but for Household Items feature.
// Functional behavior is identical; only naming and displayed text differ.
const HouseholdItemsHome = ({ setMenuOptions }) => {
  const { accounts } = useMsal();

  useEffect(() => {
    setMenuOptions('Household Items');
  }, []);

  if (accounts[0]?.idTokenClaims?.roles?.includes('PayrollAdmin')) {
    // mountOnEnter: the access list only loads when the Page Access tab is opened
    return (
      <Tabs id="household-items-tabs" defaultActiveKey="submissions" className="px-4 pt-4" mountOnEnter>
        <Tab eventKey="submissions" title="Household Items">
          <HouseholdItemsAdmin setMenuOptions={setMenuOptions} />
          <HouseholdItemsForm setMenuOptions={setMenuOptions} />
        </Tab>
        <Tab eventKey="access" title="Page Access">
          <PageAccessManager endpoint="householditems" pageName="Household Items" />
        </Tab>
      </Tabs>
    );
  }
  return <HouseholdItemsForm setMenuOptions={setMenuOptions} />;
};

export default HouseholdItemsHome;
